export const COMPATIBILITY_ANCHOR = 'compatibility';
